import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"

// ************************** Add ***************************
const buildAddDiscount = function(errorHandler) {
	return async function({ policyId, endorsementId, input, store }) {
		const query = gql`
			mutation addDiscount(
				$policyId: String!
				$endorsementId: String
				$input: addDiscountToOfferInput!
			) {
				addDiscount(
					policyId: $policyId
					endorsementId: $endorsementId
					input: $input
				) {
					createdStatus {
						id
					}
					errors
					status
				}
			}
		`
		const variables = { policyId, endorsementId, input }
		const res = await api({ query, variables })
		errorHandler(res?.errors, res?.data?.addDiscount, store)
		return {
			status: res?.data?.addDiscount?.status,
			id: res?.data?.addDiscount?.createdStatus?.id
		}
	}
}

// ************************** Remove ***************************
const buildRemoveDiscount = function(errorHandler) {
	return async function({ policyId, endorsementId, discountId, store }) {
		const query = gql`
			mutation removeDiscount(
				$policyId: String!
				$endorsementId: String
				$discountId: String!
			) {
				removeDiscount(
					policyId: $policyId
					endorsementId: $endorsementId
					discountId: $discountId
				) {
					createdStatus {
						id
					}
					errors
					status
				}
			}
		`
		const variables = { policyId, endorsementId, discountId }
		const res = await api({ query, variables })
		errorHandler(res?.errors, res?.data?.removeDiscount, store)
		return {
			status: res?.data?.removeDiscount?.status,
			id: res?.data?.removeDiscount?.createdStatus?.id
		}
	}
}
// ************************** Add Loading ***************************
const buildAddLoading = function(errorHandler) {
	return async function({ policyId, endorsementId, input, store }) {
		const query = gql`
			mutation addLoading(
				$policyId: String!
				$endorsementId: String
				$input: loadingInput!
			) {
				addLoading(
					policyId: $policyId
					endorsementId: $endorsementId
					input: $input
				) {
					createdStatus {
						id
					}
					errors
					status
				}
			}
		`
		const variables = { policyId, endorsementId, input }
		const res = await api({ query, variables })
		errorHandler(res?.errors, res?.data?.addLoading, store)
		return {
			status: res?.data?.addLoading?.status,
			id: res?.data?.addLoading?.createdStatus?.id
		}
	}
}

// ************************** Remove Loading ***************************
const buildRemoveLoading = function(errorHandler) {
	return async function({ policyId, endorsementId, loadingId, store }) {
		const query = gql`
			mutation removeLoading(
				$policyId: String!
				$endorsementId: String
				$loadingId: String!
			) {
				removeLoading(
					policyId: $policyId
					endorsementId: $endorsementId
					loadingId: $loadingId
				) {
					createdStatus {
						id
					}
					errors
					status
				}
			}
		`
		const variables = { policyId, endorsementId, loadingId }
		const res = await api({ query, variables })
		errorHandler(res?.errors, res?.data?.removeLoading, store)
		return {
			status: res?.data?.removeLoading?.status,
			id: res?.data?.removeLoading?.createdStatus?.id
		}
	}
}

export {
	buildRemoveDiscount,
	buildAddDiscount,
	buildRemoveLoading,
	buildAddLoading
}
